export default __webpack_public_path__ + "static/media/DSCN6689.db033253.JPG";